import { DOM } from './DOM'

export class TableHeightByFixedWidth {
  constructor (data, width, fontSize, padding) {
    this._init(data, width, fontSize, padding)
  }

  _init (data, width, fontSize, padding) {
    let tableStyle = {
      'position': 'fixed',
      'top': '50px',
      'fontSize': fontSize,
      'visibility': 'hidden'
    }

    let tdStyle = {
      'width': `${width}rem`,
      'fontSize': fontSize,
      'padding': padding
    }

    this.data = data
    this.width = width
    this.dom = new DOM('#app')

    this.table = this.dom.create('table', 'test-table')
    this.dom.style(this.table, tableStyle)
    this.dom.add('#app', this.table)
    this.dom.add('#test-table', this.dom.create('tr'))
    this.td = this.dom.create('td')
    this.dom.add('#test-table tr', this.td)
    this.dom.style(this.td, tdStyle)
  }

  calc (str, width) {
    this.td.innerHTML = str
    return this.dom.rect(this.td).height + 5
  }

  clear (width) {
    this.dom.remove('#app', this.table)
  }

  getHeightMap () {
    let dataLen = this.data.length
    let dataChildLen = this.data[0].length
    let str
    let heightMap = []
    let maxHeight = 0
    let currentHeight = 0
    for (let i = 0; i < dataChildLen; i++) {
      for (let j = 0; j < dataLen; j++) {
        str = (typeof this.data[j][i].value !== 'undefined' && this.data[j][i].value !== null) ? this.data[j][i].value : this.data[j][i]
        currentHeight = this.calc(str, this.width)
        maxHeight = (currentHeight > maxHeight) ? currentHeight : maxHeight
      }
      heightMap.push(maxHeight)
      maxHeight = 0
    }
    // this.clear()
    return heightMap
  }

  modifyTableRowHeight (el) {
    let heightMap = this.getHeightMap()
    let containers = this.dom.findAll(el)
    this.dom.each(containers, container => {
      this.dom.each(container.children, tables => {
        this.dom.each(tables.children, (tr, i) => {
          tr.style.height = `${heightMap[i]}px`
        })
      })
    })
    this.clearDummys()
  }

  clearDummys () {
    while (document.getElementById('test-table')) {
      this.dom.$root.removeChild(document.getElementById('test-table'))
    }
  }
}



// WEBPACK FOOTER //
// ./src/Services/tableLayoutHelper/height.js